import { Button } from '@crono-one/design-system';
import { Tooltip } from '@mui/material';
import React from 'react';

interface IPropertyNotTagAction<T = unknown> {
  tooltip?: string;
  icon?: React.ReactNode;
  handle?: () => void;
  element?: (props?: T) => React.ReactElement;
  title?: string;
  key: string;
  hidden?: boolean;
  disabled?: boolean;
}

export interface IExternalPropertyNotTagFooterProps {
  actions: IPropertyNotTagAction[];
}

export const ExternalPropertyNotTagFooter = ({
  actions,
}: IExternalPropertyNotTagFooterProps) => {
  const filteredActions = actions.filter((action) => !action.hidden);

  return (
    <div className="flex gap-1 justify-end pr-1">
      {filteredActions.map((action) => (
        <React.Fragment key={action.key}>
          {action.element ? (
            action.element()
          ) : (
            <Tooltip
              arrow
              hidden={!action.tooltip}
              title={action.tooltip}
              enterDelay={400}
              enterNextDelay={400}
            >
              <div className="max-h-6">
                <Button
                  className="p-0 size-6 rounded-full"
                  variant="ghost"
                  tone="gray"
                  size="md"
                  disabled={action.disabled}
                  onClick={action.handle}
                >
                  {action.icon}
                </Button>
              </div>
            </Tooltip>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
